import { Mui } from "@osu/react-ui";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearRowData } from '../../services/graphql/slices/manage-applications-slice';
import Sidebar from "./sidebar";
import useReviewerTabs from "./useReviewerTabs";
import ReviewerList from "./reviewerList";
import AssignableOrAssignedApplications from "./reviewerContent";
import Dialog from "./dialog";

function ManageApplications() {
    const [showSidebar, setShowSidebar] = useState(true);
    const assignAreaSize = showSidebar ? 9 : 12;
    
    return (
        <Mui.Grid container>
            <Mui.Grid item xs={3}><Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} /></Mui.Grid>
            <Mui.Grid item xs={assignAreaSize}><ReviewerAssignUnassignArea /></Mui.Grid>
        </Mui.Grid>
    );
}

function ReviewerAssignUnassignArea() {
    const dispatch = useDispatch();
    
    const handleTabClose = () => {
        dispatch(clearRowData());
    };
    
    const { tabs, addTab, ManageAppTabs } = useReviewerTabs(handleTabClose);
    const selectedTab = tabs.findIndex(tab => tab.selected === true);
    const reviewer = tabs[selectedTab];
    
    return (
        <Mui.Box sx={{ marginLeft: "0.5rem" }}>
            {ManageAppTabs}
            
            <Mui.Box sx={{ marginTop: "0.25rem" }}>
                <ReviewerList addTab={addTab} showReviewers={selectedTab === 0} />

                <AssignableOrAssignedApplications selectedTab={!!selectedTab && reviewer} programId="honors" /> {/* TODO: replace this with a more dynamic system */}
            </Mui.Box>
            
            <Dialog selectedReviewer={reviewer} />
        </Mui.Box>
    );
}

export default ManageApplications;
